import { AppType } from '../../constants/AppType';
import Applications from '../../components/Applications/Applications';
import withHasPermission from '../../hoc/withHasPermission';
import { Permission } from '../../permissions/permission';

export const VirtualApps = withHasPermission(() => {
    return <Applications type={AppType.VirtualApp} title={'Virtual Apps'} icon={'fa-solid fa-window-maximize'} />;
}, Permission.Root_VirtualApps);
